interface Attribute {
	key: string;
	value: {
		valueType: string;
		int64Value: number;
		stringValue: string;
		boolValue: boolean;
	};
}
interface ReferenceAttribute {
	referenceType: string;
	attributes: Array<Attribute>;
}

export interface Tag {
	TagName: string;
	TagPropertyKey: string;
	value: {
		valueType: string;
		boolValues: Array<boolean>;
		stringValues: Array<string>;
		floatValues: Array<number>;
		int64Values: number[];
		int32Values: number[];
	};
}
export interface PlaceEntry {
	placeId: number;
	overlap: boolean;
	geometry: string;
	representationType: string;
	timeRange: {
		startTime: {
			seconds: number;
		};
		endTime: {
			seconds: number;
		};
	};
	tags: Array<Tag>;
	referenceAttributes: Array<ReferenceAttribute>;
}
export enum AllSegmentTypes {
	'DRY_RUN_SEGMENT' = 'DRY_RUN_SEGMENT',
	'POLY_SEGMENT' = 'POLY_SEGMENT',
	'STANDING_EVENT' = 'STANDING_EVENT',
	'PARKING_EVENT' = 'PARKING_EVENT',
}

export interface TimelineDataInterface {
	startTime: number;
	AREA_IN_ACRES?: number;
	endTime: number;
	tagData: { [x: string]: number | string | boolean };
	metadata: {
		geometry: Array<{
			lat: number;
			lng: number;
		}>;
		placeId: number;
		type: string;
		polygonType?: string;
	};
}
export interface PointsResponseInterface {
	IOTDeviceStatus: number[];
	SupplyGood: number[];
	DeviceId: number[];
	DeviceNetworkStatusList: number[];
	Latitude: number[];
	LocationArea: string[];
	GsmSignalStrength: number[];
	Accuracy: number[];
	InternalTemp: number[];
	LoadedBatteryVoltage: number[];
	SequenceNumber: number[];
	IgnitionOn: number[];
	HeadingDegrees: number[];
	SprayerOn: number[];
	Speed: number[];
	IgnitionStatusList: number[];
	DeviceTowingStatusList: number[];
	BatteryPercentage: number[];
	ExtPowerStatusList: number[];
	InternalBatteryStatusList: number[];
	Tehsil: string[];
	ExternalPowerConnected: number[];
	Longitude: number[];
	TimeStamp: number[];
	SpeedLimitStatusList: number[];
	MachineNumber: string[];
	State: string[];
	LogReason: string[];
	statusesEnumsMapping: StatusesEnumsMapping;
	OdometerInKm: number[];
	AccidentStatusList: number[];
	EngineOn: number[];
	District: string[];
	InternalBatteryVoltage: number[];
	ExternalVoltage: number[];
	Altitude: number[];
}

export interface StatusesEnumsMapping {
	IgnitionStatusList: string[];
	DeviceTowingStatusList: string[];
	IOTDeviceStatus: string[];
	ExtPowerStatusList: string[];
	InternalBatteryStatusList: string[];
	DeviceNetworkStatusList: string[];
	AccidentStatusList: string[];
	SpeedLimitStatusList: string[];
}

export interface PointTagDataInterface {
	IOTDeviceStatus: number;
	SupplyGood: number;
	DeviceId: number;
	DeviceNetworkStatusList: number;
	Latitude: number;
	LocationArea: string;
	GsmSignalStrength: number;
	Accuracy: number;
	InternalTemp: number;
	LoadedBatteryVoltage: number;
	SequenceNumber: number;
	IgnitionOn: number;
	HeadingDegrees: number;
	SprayerOn: number;
	Speed: number;
	IgnitionStatusList: number;
	DeviceTowingStatusList: number;
	BatteryPercentage: number;
	ExtPowerStatusList: number;
	InternalBatteryStatusList: number;
	Tehsil: string;
	ExternalPowerConnected: number;
	Longitude: number;
	TimeStamp: number;
	SpeedLimitStatusList: number;
	MachineNumber: string;
	State: string;
	LogReason: string;
	OdometerInKm: number;
	AccidentStatusList: number;
	EngineOn: number;
	District: string;
	InternalBatteryVoltage: number;
	ExternalVoltage: number;
	Altitude: number;
	machineNumber: string;
}
